import { createContext } from "react";
const McqDataContext = createContext();

export default McqDataContext;